<!-- Color Picker Input for Inspector -->
<script lang="ts">
  import ColorPicker from '@/ui/base/ColorPicker.svelte';

  let {
    value = $bindable(0xffffff),
    onChange,
  }: {
    value: number;
    onChange?: (value: number) => void;
  } = $props();

  function handleChange(newValue: number) {
    value = newValue;
    onChange?.(value);
  }
</script>

<ColorPicker {value} onChange={handleChange} />
